import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import * as Carrom from "carrom-king-engine";
import { BootScene } from "../BootScene";

export class GemsContainerMatchingScene extends Phaser.GameObjects.Container {

    private gemsLabel: Phaser.GameObjects.Text;
    private gemsCounter: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        for (let i = 0; i < 8; i++) {

            const gem = new Phaser.GameObjects.Image(this.scene, i % 2 ? 160 : -160, 20, "texture_atlas_1", "icon_top_gems");
            gem.angle = 15 - 30 * Math.random();
            gem.setScale(.35 + .2 * Math.random());
            gem.alpha = 0;
            if (Math.random() > .5) {
                gem.scaleX *= -1;
            }
            if (i < 3) {
                gem.tint = 0xAAAAAA;
            } else if (i < 5) {
                gem.tint = 0xCCCCCC;
            }
            this.add(gem);

            const scale = .65 + .35 * i / 7;
            const delay = 40 * i + 500;

            this.scene.tweens.add({
                targets: gem,
                x: 35 - 75 * Math.random(),
                y: 150 + 15 - 30 * Math.random(),
                scaleX: scale * Math.sign(gem.scaleX),
                scaleY: scale,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 600,
                delay: delay
            });
        }

        this.gemsCounter = 0;

        this.gemsLabel = new Phaser.GameObjects.Text(this.scene, 0, 230 + (BootScene.textYgap * -114), this.gemsCounter.toString(), { fontFamily: "Teko-Medium", fontSize: "65px", color: "#FFFFFF" });
        this.gemsLabel.setShadow(0, 5, "#061f55", 0, false, true);
        this.gemsLabel.setOrigin(.5,BootScene.originY);
        this.gemsLabel.alpha = 0;
        this.add(this.gemsLabel);

        this.scene.tweens.add({
            targets: this.gemsLabel,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 400,
            delay: 600
        });

        let gemsPrize: number;

        if (GameVars.difficulty === Carrom.Difficulty.BEGINNER) {
            gemsPrize = GameConstants.BEGINNER_MATCH_PRIZE;
        } else {
            gemsPrize = GameConstants.EXPERT_MATCH_PRIZE;
        }

        this.scene.tweens.add({
            targets: this,
            gemsCounter: gemsPrize / 5,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 400,
            delay: 600,
            onUpdate: function (): void {
                this.gemsLabel.text = (Math.floor(this.gemsCounter) * 5).toString();
            },
            onUpdateScope: this
        });
    }
}
